/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationFormCommentCountsDto
 */
export interface ApplicationFormCommentCountsDto {
    /**
     * Keys are formElementId (UUID), values are comment counts.
     * @type {{ [key: string]: number; }}
     * @memberof ApplicationFormCommentCountsDto
     */
    counts: { [key: string]: number; };
}

/**
 * Check if a given object implements the ApplicationFormCommentCountsDto interface.
 */
export function instanceOfApplicationFormCommentCountsDto(value: object): value is ApplicationFormCommentCountsDto {
    if (!('counts' in value) || value['counts'] === undefined) return false;
    return true;
}

export function ApplicationFormCommentCountsDtoFromJSON(json: any): ApplicationFormCommentCountsDto {
    return ApplicationFormCommentCountsDtoFromJSONTyped(json, false);
}

export function ApplicationFormCommentCountsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormCommentCountsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'counts': json['counts'],
    };
}

export function ApplicationFormCommentCountsDtoToJSON(json: any): ApplicationFormCommentCountsDto {
    return ApplicationFormCommentCountsDtoToJSONTyped(json, false);
}

export function ApplicationFormCommentCountsDtoToJSONTyped(value?: ApplicationFormCommentCountsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counts': value['counts'],
    };
}

